import Http from 'lib/http';
import { IEntityInfo } from './types';

export const fetchEntityInfo = (fetcher = Http): Promise<IEntityInfo> => fetcher.get('profile/entity');
export const saveEntityInfo = (data: IEntityInfo): Promise<IEntityInfo> => Http.patch('profile/entity', data);
export const getInvoice = (amount: number): Promise<{}> =>
  Http.get('profile/entity/invoice.pdf', { amount }, { responseType: 'arraybuffer' }).then(
    (blob: any) => new Blob([blob as Blob], { type: 'application/pdf' })
  );

export const getContract = (): Promise<{}> =>
  Http.get('profile/entity/contract.pdf', {}, { responseType: 'arraybuffer' }).then(
    (blob: any) => new Blob([blob as Blob], { type: 'application/pdf' })
  );

export const uploadContracts = (files?: File[]): Promise<{}> => {
  if (files?.length) {
    const formData = new FormData();
    files.map(f => formData.append('documents[]', f, f.name));

    return Http.post('profile/entity/upload', formData);
  }

  return Http.post('profile/entity/upload');
};

export const fetchContractFileByLink = (url: string): Promise<File> => {
  const fileName = url.match(/[^\/]+$/)?.[0] || '';

  return Http.get(
    url,
    {},
    {
      responseType: 'arraybuffer',
    }
  ).then((blob: any) => new File([blob as Blob], fileName));
};
